import { StarIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  VisuallyHidden,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { AuthData, useAuth } from "../contexts/Auth";
import { usePremium } from "../contexts/Premium";
import { Logo } from "./Logo";
import { MobileNav } from "./MobileNav";
import { NavLink } from "./NavLink";

const Navigation = () => {
  const { authData } = useAuth() as { authData: AuthData };
  const { isPremium } = usePremium() as { isPremium: boolean };
  return (
    <Box as="header" bg={"gray.900"} borderBottomWidth="1px">
      <Box maxW="7xl" mx="auto" py="4" px={{ base: "6", md: "8" }}>
        <Flex as="nav" justify="space-between">
          <HStack spacing="8">
            <Box as="a" href="/" rel="home">
              <VisuallyHidden>Redwing</VisuallyHidden>
              <Logo />
            </Box>
            {!authData && (
              <NavLink.Desktop
                to="/community"
                display={{ base: "none", lg: "block" }}
              >
                The Panel
              </NavLink.Desktop>
            )}
            {!!authData && (
              <HStack display={{ base: "none", lg: "flex" }} spacing="8">
                <NavLink.Desktop to="/news">Feed</NavLink.Desktop>
                <NavLink.Desktop to="/reading">Reading</NavLink.Desktop>
                <NavLink.Desktop to="/browse">Browse</NavLink.Desktop>
                <NavLink.Desktop to="/my-orders">My Orders</NavLink.Desktop>
                <NavLink.Desktop to="/community">The Panel</NavLink.Desktop>
                {authData.role === 1 && (
                  <NavLink.Desktop to="/reading-orders/all">
                    Admin
                  </NavLink.Desktop>
                )}
              </HStack>
            )}
          </HStack>
          <Flex align="center">
            <HStack spacing="8" display={{ base: "none", md: "flex" }}>
              {!!authData ? (
                <>
                  {!isPremium && (
                    <Button
                      as={Link}
                      leftIcon={<StarIcon />}
                      colorScheme="red"
                      color="white"
                      to="/go-premium"
                    >
                      Go Premium
                    </Button>
                  )}
                  {authData && authData.partnerId && (
                    <NavLink.Desktop to="/partnership/reading-orders/all">
                      {authData.partnerName}
                    </NavLink.Desktop>
                  )}
                  <NavLink.Desktop to="/profile">
                    <Flex alignItems="center" justifyContent="center">
                      {authData.userHandle || "Profile"}
                      <Avatar
                        size="md"
                        ml="3"
                        name={authData?.userHandle || authData?.firstName}
                        src={authData.profilePicture}
                      />
                    </Flex>
                  </NavLink.Desktop>
                </>
              ) : (
                <>
                  <NavLink.Desktop to="/login">Log in </NavLink.Desktop>
                  <Link to="/signup">
                    <Button colorScheme="red" color="white" rounded="full">
                      Signup
                    </Button>
                  </Link>
                </>
              )}
            </HStack>
            <Box ml="5">
              <MobileNav />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Navigation;
